"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivacyAndSecurity = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Box_1 = tslib_1.__importDefault(require("@material-ui/core/Box"));
var index_1 = require("../../../index");
var setting_divider_1 = require("../../component/setting-divider");
function PrivacyAndSecurity() {
    return (react_1.default.createElement(index_1.SettingContainer, null,
        react_1.default.createElement(index_1.DefaultTitle, null, "\u9690\u79C1\u4E0E\u5B89\u5168"),
        react_1.default.createElement(index_1.DesTitle, null, "\u5B89\u5168\u7684\u79C1\u4FE1 "),
        react_1.default.createElement(index_1.SmallTitle, null, "\u81EA\u52A8\u626B\u63CF\u5E76\u5220\u9664\u60A8\u6536\u5230\u7684\u5305\u542B\u4E0D\u96C5\u5A92\u4F53\u5185\u5BB9\u7684\u79C1\u4FE1."),
        react_1.default.createElement(index_1.SettingBoxRadioButtonGroupView, { data: [
                {
                    text: "保护我的安全",
                    des: "扫描每个人的私信",
                    color: "rgb(67, 181, 129)",
                },
                {
                    text: "我的朋友都很好",
                    des: "扫描每个人的私信，除非他们都是朋友。",
                    color: "rgb(250, 166, 26)",
                },
                {
                    text: "我活在生活的边缘",
                    des: " 关闭此功能,不扫描任何东西,直到走向黑暗的一面",
                    color: "rgb(240, 71, 71)",
                },
            ], onClick: function (item) { return console.log(item); } }),
        react_1.default.createElement(Box_1.default, { height: 40 }),
        react_1.default.createElement(index_1.DesTitle, null, "\u670D\u52A1\u5668\u9ED8\u8BA4\u9690\u79C1\u8BBE\u7F6E"),
        react_1.default.createElement(Box_1.default, { height: 4 }),
        react_1.default.createElement(index_1.SelectButtonGroupView, { data: [
                {
                    text: "允许服务器成员直接向您发起私聊。",
                    des: "当您加入一个新的服务器时，将应用此设置。它不适用于您现有的服务器。",
                },
            ] },
            react_1.default.createElement(index_1.SettingSwitchButton, { onChange: function () { return console.log("ok"); } })),
        react_1.default.createElement(Box_1.default, { height: 40 }),
        react_1.default.createElement(index_1.DesTitle, null, "\u8C01\u53EF\u4EE5\u628A\u60A8\u52A0\u4E3A\u597D\u53CB"),
        react_1.default.createElement(index_1.SelectButtonGroupView, { data: [
                {
                    text: "所有人",
                },
                {
                    text: "好友的好友",
                },
                {
                    text: "服务器成员",
                },
            ] },
            react_1.default.createElement(index_1.SettingSwitchButton, { onChange: function (i) {
                    console.log(i);
                } })),
        react_1.default.createElement(index_1.DesTitle, null, "\u6211\u4EEC\u5982\u4F55\u4F7F\u7528\u60A8\u7684\u6570\u636E"),
        react_1.default.createElement(index_1.SelectButtonGroupView, { data: [
                {
                    text: "使用数据改善 Discord",
                    des: "该设置可以让我们使用和处理关于您是如何使用 Discord 的相关信息，作分析用。例如，通过它我们可以使您参与新功能的测试。",
                },
                {
                    text: "使用数据自定义我的 Discord 体验",
                    des: "这项设置可以使用信息(如您平时的聊天对象和您玩的游戏)为您量身定制 Discord。",
                },
                {
                    text: "服务器成员",
                },
            ] },
            react_1.default.createElement(index_1.SettingSwitchButton, { onChange: function (i) {
                    console.log(i);
                } })),
        react_1.default.createElement(Box_1.default, { height: 20 }),
        react_1.default.createElement(index_1.DefaultTitle, null, "\u4F7F\u7528\u6570\u636E\u8BA9\u5176\u6B63\u5E38\u5DE5\u4F5C"),
        react_1.default.createElement(index_1.SmallTitle, null,
            "\u6211\u4EEC\u9700\u8981\u4FDD\u5B58\u548C\u5904\u7406\u4E00\u4E9B\u6570\u636E\u6765\u63D0\u4F9B\u57FA\u7840\u6027\u7684 Discord \u670D\u52A1\uFF0C\u5982\u60A8\u7684\u6D88\u606F\u3001\u60A8\u6240\u5728\u7684\u670D\u52A1\u5668\u548C\u60A8\u7684\u79C1\u4FE1\u3002\u60A8\u53EF\u4EE5\u901A\u8FC7",
            react_1.default.createElement(index_1.SettingLinkButton, { href: "https://www.baidu.com/" }, "\u5173\u95ED\u6216\u5220\u9664\u8D26\u53F7")),
        react_1.default.createElement(Box_1.default, { height: 20 }),
        react_1.default.createElement(setting_divider_1.SettingDivider, null),
        react_1.default.createElement(Box_1.default, { height: 20 }),
        react_1.default.createElement(index_1.DefaultTitle, null, "\u8BF7\u6C42\u6211\u7684\u5168\u90E8\u6570\u636E"),
        react_1.default.createElement(index_1.SmallTitle, null,
            react_1.default.createElement("span", null,
                react_1.default.createElement(index_1.SettingLinkButton, { href: "https://www.baidu.com/" }, "\u4E86\u89E3\u66F4\u591A"),
                "\u5173\u4E8E\u83B7\u53D6\u6570\u636E\u8FC7\u7A0B")),
        react_1.default.createElement(Box_1.default, { height: 20 }),
        react_1.default.createElement(index_1.SettingDefaultButton, { onClick: function (item) { return console.log(item); } }, "\u8BF7\u6C42\u6570\u636E"),
        react_1.default.createElement(Box_1.default, { height: 40 }),
        react_1.default.createElement(index_1.BorderTitleView, { text: react_1.default.createElement("span", null,
                "\u5FEB\u901F\u9605\u8BFB\u6211\u7684",
                react_1.default.createElement(index_1.SettingLinkButton, { href: "https://www.baidu.com/" }, "\u670D\u52A1\u6761\u6B3E"),
                "\u548C",
                react_1.default.createElement(index_1.SettingLinkButton, { href: "https://www.baidu.com/" }, "\u9690\u79C1\u6743\u653F\u7B56"),
                "\u5427") })));
}
exports.PrivacyAndSecurity = PrivacyAndSecurity;
//# sourceMappingURL=PrivacyAndSecurity.js.map